import { Injectable } from '@angular/core';
import { User } from '@modules/auth/models';
import { UserService } from '@modules/auth/services';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export interface UsersLimitStatus {
    atLimit: boolean;
    currentCount: number;
    effectiveLimit: number;
    limitUsers: number;
    purchasedUsers: number;
    extendUsers: number | null;
}

@Injectable()
export class UserAssociatedService {
    private _usersAssociated$: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
    private _limitStatus$: BehaviorSubject<UsersLimitStatus | null> = new BehaviorSubject<UsersLimitStatus | null>(null);

    constructor(private userService: UserService) {}

    get usersAssociated$() {
        return this._usersAssociated$;
    }

    set usersAssociated(users: User[]) {
        this._usersAssociated$.next([...users]);
    }

    get limitStatus$() {
        return this._limitStatus$;
    }

    set limitStatus(status: UsersLimitStatus | null) {
        this._limitStatus$.next(status);
    }

    get atLimit(): boolean {
        return !!this._limitStatus$.value?.atLimit;
    }

    refreshLimitStatus(): Observable<any> {
        return this.userService.getUsersLimitStatus$().pipe(
            tap((res: any) => {
                this.limitStatus = res.data;
            }),
        );
    }
}
